import { create } from 'zustand';


type CookieConsentView = 'banner' | 'settings';

type CookieConsentStore = {
    isOpen: boolean;
    view: CookieConsentView;
    open: (view?: CookieConsentView) => void;
    setView: (view: CookieConsentView) => void;
    close: () => void;
};


export const useCookieConsentStore = create<CookieConsentStore>((set) => ({
    isOpen : false,
    view   : 'banner',
    open   : (view = 'banner') => set({ isOpen: true, view }),
    setView: (view) => set({ view }),
    close  : () => set({ isOpen: false }),
}));


export function openCookieSettings (): void {
    useCookieConsentStore.getState().open('settings');
}
